import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { SeRegistrationUiRegistrationCardModule } from '@se-po/se-registration-ui-registration-card'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options'
import { SeFeIconModule, seFeIconChevronDown, seFeIconSpotFlatBall, seFeIconSpotServiceBreakdown } from 'se-fe-icon'
import { SeFeListModule } from 'se-fe-list'
import { SeFeMenuModule } from 'se-fe-menu'
import { SeFePageModule } from 'se-fe-page'
import { SeFeSearchModule } from 'se-fe-search'
import { SeFeTabGroupModule } from 'se-fe-tabs'
import { OpenRegistrationListComponent } from './open-registration-list/open-registration-list.component'
import { SeFeToolbarModule } from 'se-fe-toolbar'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { OpenRegistrationFilterComponent } from './open-registration-filter/open-registration-filter.component'
import { OpenRegistrationSearchComponent } from './open-registration-search/open-registration-search.component'
import { SeFeToastModule } from 'se-fe-toast'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeRegistrationUiRegistrationCardModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeChipModule,
    SeFeFormFieldOptionsModule,
    SeFeIconModule.include([
      seFeIconChevronDown,
      seFeIconSpotFlatBall,
      seFeIconSpotServiceBreakdown,
    ]),
    SeFeListModule,
    SeFeMenuModule,
    SeFeToolbarModule,
    SeFePageModule,
    SeFeSearchModule,
    SeFeTabGroupModule,
    SeFeToastModule,
    SeFeTranslationsModule,
  ],
  declarations: [
    OpenRegistrationFilterComponent,
    OpenRegistrationListComponent,
    OpenRegistrationSearchComponent,
  ],
  exports: [OpenRegistrationListComponent, OpenRegistrationSearchComponent],
})
export class SeRegistrationUiFeatureOpenRegistrationListModule {}
